import ApiService, { ConfigService } from "@/common/api.service"
import {
  FETCH_LANGS,
  FETCH_CONFIG_ITEMS,
  CONFIG_ITEM_CREATE,
  CONFIG_ITEMS_EDIT
} from "./actions.type"
import {
  SET_CONFIG_ITEM,
  SET_CONFIG_ITEMS,
  SET_LANGS
} from "./mutations.type";
import { displayNotification } from "@/common/notification";

const defaultProjectConfig = require("@/common/project-config.default")
let projectConfig = {}
try {
  projectConfig = require(`@/common/project-config.${process.env.VUE_APP_PROJECT_CONFIG_TEMPLATE}`)
} catch {
  projectConfig = {}
}

const initialState = {
  projectConfig: Object.assign({}, defaultProjectConfig, projectConfig),
  configItems: [],
  langs: null,
  activeLanguage: {
    code: 'en',
    rtl: false
  }

};

export const state = { ...initialState };

export const actions = {
  async [FETCH_CONFIG_ITEMS](context) {
    const { data } = await ConfigService.get();
    context.commit(SET_CONFIG_ITEMS, data.config);
    return data.config;
  },

  async [CONFIG_ITEM_CREATE]({ state, commit }, item) {
    return await ConfigService.create(item)
  },

  async [CONFIG_ITEMS_EDIT]({ state, commit }, items) {
    commit(SET_CONFIG_ITEMS, items);
    
    try {
      return await ConfigService.update({ items: items })
    } catch {
      displayNotification("Updating config failed", "warning");
    }
  },

  async [FETCH_LANGS](context) {
    return ApiService.get("langs")
      .then(({ data }) => {
        context.commit(SET_LANGS, data.langs);
        return data;
      })
      .catch(() => {
        // #todo SET_ERROR cannot work in multiple states
        // context.commit(SET_ERROR, response.data.errors)
      });
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {

  [SET_CONFIG_ITEM](state, { key, value }) {
    let item = _.find(state.configItems, item => {
      return item.key === key
    })
    item.value = value
  },

  [SET_CONFIG_ITEMS](state, items) {
    state.configItems = items;
  },

  [SET_LANGS](state, langs) {
    state.langs = langs;
  },

  SET_ACTIVE_LANGUAGE (state, payload) {
    state.activeLanguage = payload;
  }
};

const getters = {
  configItems(state) {
    return state.configItems;
  },
  langs(state) {
    return state.langs;
  },
  activeLanguage(state) {
    return state.activeLanguage
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
